const getCookie = (cookieName) => {
    let cookiesArray = document.cookie.split(';')
    for (const cookie of cookiesArray) {
        if (cookie.includes(cookieName)) {
            return cookie.split("=")[1];
        }
    }
    return ""
}

window.storeCookie = (cookieValue, cookieName) => {
    const storedCookie = getCookie(cookieName) || '[]';
    let groupArray = JSON.parse(storedCookie);

    if (groupArray.includes(cookieValue)) {
        groupArray = groupArray.filter(id => id !== cookieValue);
    } else {
        groupArray.push(cookieValue);
    }
    document.cookie = `${cookieName}=${JSON.stringify(groupArray)}; path=/; domain=${window.location.hostname}; SameSite=None; expires=Session; Secure;`;
};

